<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

import Button from '~/ui/Button.vue'

interface Events {
  (e: 'update:modelValue', value: boolean): void
}

interface Props {
  modelValue: boolean
}

const { t } = useI18n()

const emit = defineEmits<Events>()
const props = defineProps<Props>()
const value = useVModel(props, 'modelValue', emit)
</script>

<template>
  <Button
    class="color-default-solid shape-field-minimal"
    ui-block-size="40"
    @click.prevent="value = !value"
  >
    <Icon :icon="value ? 'bi:chevron-expand' : 'bi:chevron-contract'" />
    <span v-if="value">
      {{ t('components.common.CollapseLink.button.expand') }}
    </span>
    <span v-else>
      {{ t('components.common.CollapseLink.button.collapse') }}
    </span>
    <i :class="[{ down: !value, right: value }, 'angle', 'icon']" />
  </Button>
</template>
